<template>
  <el-dropdown @command="handleCommand">
    <el-button type="primary" class="express-new" size="small">
      +&nbsp;Express New
      <i class="el-icon-arrow-down el-icon--right"></i>
    </el-button>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item command="InvoiceAdd">+&nbsp;Sales Invoice</el-dropdown-item>
      <el-dropdown-item command="CreditNoteAdd">+&nbsp;Sales Credit Note</el-dropdown-item>
      <el-divider></el-divider>
      <el-dropdown-item command="PurchaseOrderAdd">+&nbsp;Purchase Order</el-dropdown-item>
      <el-dropdown-item command="BillAdd">+&nbsp;Bills</el-dropdown-item>
      <el-dropdown-item command="BillCreditNoteAdd">+&nbsp;Bill Credit Note</el-dropdown-item>
      <el-divider></el-divider>
      <el-dropdown-item command="TransfersAdd">+&nbsp;Transfer</el-dropdown-item>
      <el-dropdown-item command="AdjustmentsAdd">+&nbsp;Adjustment</el-dropdown-item>
      <el-divider></el-divider>
      <el-dropdown-item command="ProdAdd">+&nbsp;Product</el-dropdown-item>
      <el-dropdown-item command="CsrAdd">+&nbsp;Customer</el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>
<script>
import {
  routeINV,
  routeCN,
  routePO,
  routeBCN,
  routeBL,
  routeTR,
  routeAJ,
  routeInfoPRDC,
  routeInfoCSR
} from '../router'

export default {
  name: 'HeaderExpressDropDownBtn',
  methods: {
    handleCommand (command) {
      switch (command) {
        case 'InvoiceAdd':
          this.handleNew(routeINV)
          break
        case 'CreditNoteAdd':
          this.handleNew(routeCN)
          break
        case 'PurchaseOrderAdd':
          this.handleNew(routePO)
          break
        case 'BillAdd':
          this.handleNew(routeBL)
          break
        case 'BillCreditNoteAdd':
          this.handleNew(routeBCN)
          break
        case 'TransfersAdd':
          this.handleNew(routeTR)
          break
        case 'AdjustmentsAdd':
          this.handleNew(routeAJ)
          break
        case 'ProdAdd':
          this.handleBaseInfoNew(routeInfoPRDC)
          break
        case 'CsrAdd':
          this.handleBaseInfoNew(routeInfoCSR)
          break
      }
    },
    handleNew (routeName) {
      const routeData = this.$router.resolve({
        name: 'OrderAdd',
        params: { routeName: routeName }
      })
      window.open(routeData.href, '_blank')
    },
    handleBaseInfoNew (routeName) {
      const routeData = this.$router.resolve({
        name: 'BaseInfoAdd',
        params: { routeName: routeName }
      })
      window.open(routeData.href, '_blank')
    }
  }
}
</script>

<style scoped>
.el-icon-arrow-down {
  font-size: 12px;
}
.express-new {
  margin-left: 8px;
}
.el-divider {
  margin: 2px 0;
}
</style>
